module.exports = __webpack_public_path__ + "media/images/icons/satisfaction-8403b781f5409560bf29b7926bab031f.png";